import React, { useEffect, useState } from 'react'
import BurnsSegment from '../../burnsTbsa/content/BurnsSegment.content'
import { useDispatch, useSelector } from 'react-redux'
import { getBodyViewSelector } from '../../selectors/getBodyViewSelector'
import { IonChip, IonCol, IonLabel, IonRow, IonSegment, IonSegmentButton } from '@ionic/react'
import './BurnsRuleOfNines.content.css'
import { IBurnsState } from '../../store/burns.types'
import { getBurnsSelector } from '../../selectors'
import { saveBurns, setBodyAreaCalculations, setBurnColors, setBurnExams } from '../../store/burns.actions'
import BurnsSummary from '../../burnsTbsa/content/BurnsSummary.content'
import AdditionalBurns from '../../additionalBurns/AdditionalBurns.content'
import useDeviceMetrics from '../../../../../../utilities/useDeviceMetrics'
import { useTranslation } from 'react-i18next'

const BurnsRuleOfNinesContent: React.FC<any> = () => {
  const selectedBodyView = useSelector(getBodyViewSelector)
  const burnsStateData: IBurnsState = useSelector(getBurnsSelector)
  const {
    headAnterior,
    headPosterior,
    armsAnterior,
    armsPosterior,
    legsAnterior,
    legsPosterior,
    trunkAnterior,
    trunkPosterior,
    tbsaScore,
    burnsExamData,
    burnsColorData,
  } = burnsStateData

  const { isTabletInLandscape, isTablet } = useDeviceMetrics()

  const dispatch = useDispatch()
  const { t } = useTranslation()

  const [segment, setSegment] = useState<'burn-selections' | 'document-findings'>('burn-selections')

  const [colorStates, setColorStates] = useState<{ [key: string]: number }>({
    ...burnsColorData,
  })

  useEffect(() => {
    setColorStates({ ...burnsColorData })
  }, [burnsColorData])

  const colors = [
    'var(--ion-color-zoll-grey-light)',
    'var(--ion-color-zoll-red-light)',
    'var(--ion-color-zoll-red-medium)',
    'var(--ion-color-zoll-red-dark)',
  ]

  const sideSectionAnterior = (
    <IonRow>
      <IonCol className='bg-gray'>
        <IonRow>
          <IonCol>
            <IonLabel className='font-weight-bold burns-title font-size-16'>{t('burns.Front')}</IonLabel>
          </IonCol>
          <hr className='w-100 bg-white m-0' />
        </IonRow>

        <IonRow className='burns-subtitle'>
          <IonCol>
            <IonLabel className='fw-500'>{t('burns.Head')}</IonLabel>
          </IonCol>
          <IonCol className='d-flex justify-content-end ion-no-padding'>
            <IonLabel className='fw-400'>
              {headAnterior}
              {'%'}
            </IonLabel>
          </IonCol>
          <hr className='w-100 bg-white m-0' />
        </IonRow>

        <IonRow className='burns-subtitle'>
          <IonCol>
            <IonLabel className='fw-500'>{t('burns.Arms')}</IonLabel>
          </IonCol>
          <IonCol className='d-flex justify-content-end ion-no-padding'>
            <IonLabel className='fw-400'>
              {armsAnterior}
              {'%'}
            </IonLabel>
          </IonCol>
          <hr className='w-100 bg-white m-0' />
        </IonRow>

        <IonRow className='burns-subtitle'>
          <IonCol>
            <IonLabel className='fw-500'>{t('burns.Trunks')}</IonLabel>
          </IonCol>
          <IonCol className='d-flex justify-content-end ion-no-padding'>
            <IonLabel className='fw-400'>
              {trunkAnterior}
              {'%'}
            </IonLabel>{' '}
          </IonCol>
          <hr className='w-100 bg-white m-0' />
        </IonRow>

        <IonRow className='burns-subtitle'>
          <IonCol>
            <IonLabel className='fw-500'>{t('burns.Legs')}</IonLabel>
          </IonCol>
          <IonCol className='d-flex justify-content-end ion-no-padding'>
            <IonLabel className='fw-400'>
              {legsAnterior}
              {'%'}
            </IonLabel>{' '}
          </IonCol>
        </IonRow>
      </IonCol>
    </IonRow>
  )

  const sideSectionPosterior = (
    <IonRow>
      <IonCol className='bg-gray'>
        <IonRow>
          <IonCol>
            <IonLabel className='font-weight-bold burns-title font-size-16'>{t('burns.Back')}</IonLabel>
          </IonCol>
          <hr className='w-100 bg-white m-0' />
        </IonRow>

        <IonRow className='burns-subtitle'>
          <IonCol>
            <IonLabel className='fw-500'>{t('burns.Head')}</IonLabel>
          </IonCol>
          <IonCol className='d-flex justify-content-end ion-no-padding'>
            <IonLabel className='fw-400'>
              {headPosterior}
              {'%'}
            </IonLabel>
          </IonCol>
          <hr className='w-100 bg-white m-0' />
        </IonRow>
        <IonRow className='burns-subtitle'>
          <IonCol>
            <IonLabel className='fw-500'>{t('burns.Arms')}</IonLabel>
          </IonCol>
          <IonCol className='d-flex justify-content-end ion-no-padding'>
            <IonLabel className='fw-400'>
              {armsPosterior}
              {'%'}
            </IonLabel>
          </IonCol>
          <hr className='w-100 bg-white m-0' />
        </IonRow>
        <IonRow className='burns-subtitle'>
          <IonCol>
            <IonLabel className='fw-500'>{t('burns.Trunks')}</IonLabel>
          </IonCol>
          <IonCol className='d-flex justify-content-end ion-no-padding'>
            <IonLabel className='fw-400'>
              {trunkPosterior}
              {'%'}
            </IonLabel>
          </IonCol>
          <hr className='w-100 bg-white m-0' />
        </IonRow>
        <IonRow className='burns-subtitle'>
          <IonCol>
            <IonLabel className='fw-500'>{t('burns.Legs')}</IonLabel>
          </IonCol>
          <IonCol className='d-flex justify-content-end ion-no-padding'>
            <IonLabel className='fw-400'>
              {legsPosterior}
              {'%'}
            </IonLabel>
          </IonCol>
        </IonRow>
      </IonCol>
    </IonRow>
  )

  const renderChip = (label: string) => (
    <IonChip outline className='burns-chip burns-left-right-chip-size'>
      <IonLabel className='burns-chip-label'>{label}</IonLabel>
    </IonChip>
  )

  const handlePathClick = (id: string, locationName: string, locationId: number, type: string) => {
    setColorStates((prevStates) => {
      const newState = {
        ...prevStates,
        [id]: (prevStates[id] + 1) % colors.length,
      }
      const label =
        newState[id] === 1 ? '1st Degree' : newState[id] === 2 ? '2nd Degree' : newState[id] === 3 ? '3rd Degree' : ''

      const updatedBurnType = newState[id]

      let burnPercentage = '0'
      if ([2, 37, 38].includes(locationId)) {
        burnPercentage = '4.5'
      } else if ([5, 8, 9, 65, 66].includes(locationId)) {
        burnPercentage = '9'
      } else if (locationId === 83) {
        burnPercentage = '1'
      } else {
        burnPercentage = '0' // Default value if none of the conditions are met
      }

      const newEntry = {
        burnPercentage: burnPercentage,
        burnType: updatedBurnType,
        label: label,
        locationId: locationId,
        locationName: locationName,
        type: type,
        unitLabel: '%',
      }

      const existingIndex = burnsExamData?.findIndex((item) => item.locationId === locationId && item.type === type)
      let newBurnsExamData

      if (existingIndex >= 0) {
        newBurnsExamData = burnsExamData.map((item, index) => (index === existingIndex ? newEntry : item))
      } else {
        newBurnsExamData = [...burnsExamData, newEntry]
      }

      newBurnsExamData = newBurnsExamData.filter((item) => item.burnType !== 0)

      dispatch(setBurnExams(newBurnsExamData))
      dispatch(setBodyAreaCalculations())
      dispatch(saveBurns())
      dispatch(setBurnColors(newState))

      return newState
    })
  }

  return (
    <>
      {!isTabletInLandscape && (
        <IonSegment
          value={segment}
          className='custom-segment'
          onIonChange={(e) => setSegment(e.detail.value as 'burn-selections' | 'document-findings')}>
          <IonSegmentButton className='custom-segment-button' value='burn-selections'>
            {t('burns.BurnsSelection')}
          </IonSegmentButton>
          <IonSegmentButton className='custom-segment-button' value='document-findings'>
            {t('burns.DocumentFindings')}
          </IonSegmentButton>
        </IonSegment>
      )}
      {segment === 'document-findings' && (
        <div id='BurnsRuleOfNinesContent'>
          <BurnsSummary />
          <AdditionalBurns />
        </div>
      )}
      <>
        {segment === 'burn-selections' && (
          <div id='BurnsRuleOfNinesContent'>
            <IonRow className='w-100'>
              <IonCol size='4'>
                <IonLabel className='font-size-15 font-weight-bold font-roboto-condensed'> {t('burns.TBSA')}</IonLabel>
                <IonLabel className='custom-number-label'> {tbsaScore} %</IonLabel>
              </IonCol>
              <IonCol size='5' className='m-left'>
                <BurnsSegment />
              </IonCol>
            </IonRow>
            <IonRow className='d-flex align-items-start'>
              <IonCol size='3' className='p-0'>
                {sideSectionAnterior}{' '}
              </IonCol>
              <IonCol size='6'>
                <div className='right-chip-position font-roboto-condensed font-size-13'>
                  {selectedBodyView?.id === 1 ? renderChip('R') : renderChip('L')}
                </div>
                <div className='left-chip-position font-roboto-condensed font-size-13'>
                  {selectedBodyView?.id === 1 ? renderChip('L') : renderChip('R')}
                </div>
                {selectedBodyView?.id === 1 && (
                  <div className='svg-container d-flex justify-content-center w-100'>
                    <svg
                      viewBox='0 0 141 412'
                      preserveAspectRatio='none'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'>
                      <g id='AdultBurnsF'>
                        <path
                          id='66'
                          name='AdultFLegR'
                          d='M58.5 190.5L40 171.5L32.5 196L34 244.5L40.5 271.5L42 304.5L38 333.5L52.5 389.5L45 403V407L56.5 411.5H62L64 407V391L61 383.5L59.5 353.5L64 340V327.5L61 314L64 299L61 280.5L64 246V228L66.5 206.5L56.5 193.5L58.5 190.5Z'
                          fill={colors[colorStates['AdultFLegR']]}
                          onClick={() => handlePathClick('AdultFLegR', 'Right Leg', 66, 'A')}
                        />
                        <path
                          id='65'
                          name='AdultFLegL'
                          d='M84.5 190.5L103 171.5L110.5 196L109 244.5L102.5 271.5L101 304.5L105 333.5L90.5 389.5L98 403V407L86.5 411.5H81L79 407V391L82 383.5L83.5 353.5L79 340V327.5L82 314L79 299L82 280.5L79 246V228L76.5 206.5L86.5 193.5L84.5 190.5Z'
                          fill={colors[colorStates['AdultFLegL']]}
                          onClick={() => handlePathClick('AdultFLegL', 'Left Leg', 65, 'A')}
                        />
                        <path
                          id='2'
                          name='AdultFHead'
                          d='M59.5 2.5L70 0L82 2.5L91 12.5L89.5 37.5L85.5 38.5L84 48.5L81.5 52.5L83 57L79 61.5L70.5 64L62 61.5L58 57L59.5 52.5L59 48.5L56 38.5L52 37.5L51 14L59.5 2.5Z'
                          fill={colors[colorStates['AdultFHead']]}
                          onClick={() => handlePathClick('AdultFHead', 'Head', 2, 'A')}
                        />
                        <path
                          id='5'
                          name='AdultFChestLung'
                          d='M60 64L56 58.5L38 66L34 94L41.5 112L44.5 124L54 115.5L70.5 109L87 115.5L96.5 124L100.5 112L106 94L104 66L84.5 58.5L80.5 64L70.5 67L60 64Z'
                          fill={colors[colorStates['AdultFChestLung']]}
                          onClick={() => handlePathClick('AdultFChestLung', 'Chest/Lung', 5, 'A')}
                        />
                        <path
                          id='83'
                          name='AdultFGenitalia'
                          d='M78.5 192H64L60 193.5L67 203H75L82 193.5L78.5 192Z'
                          fill={colors[colorStates['AdultFGenitalia']]}
                          onClick={() => handlePathClick('AdultFGenitalia', 'Genitalia', 83, 'A')}
                        />
                        <path
                          id='38'
                          name='AdultFArmR'
                          d='M24.5 75L35.5 67.5L31 93L36 107L28 136V157L19.5 193.5L28 199L31.5 208L29.5 209.5L24.5 202L22 203V222L15 223.5L0 215.5L4 200.5L10 190L9 158.5L15 133.5L17 107.5V88.5L19.5 82.5L24.5 75Z'
                          fill={colors[colorStates['AdultFArmR']]}
                          onClick={() => handlePathClick('AdultFArmR', 'Right Arm', 38, 'A')}
                        />
                        <path
                          id='37'
                          name='AdultFArmL'
                          d='M116 75L106 67.5L109.5 93L104.5 107L112.5 136V157L121 193.5L112.5 199L109 208L111 209.5L116 202L118.5 203V222L125.5 223.5L140.5 215.5L136.5 200.5L130.5 190L131.5 158.5L125.5 133.5L123.5 107.5V88.5L121 82.5L116 75Z'
                          fill={colors[colorStates['AdultFArmL']]}
                          onClick={() => handlePathClick('AdultFArmL', 'Left Arm', 37, 'A')}
                        />
                        <path
                          id='8'
                          name='AdultFPelvis'
                          d='M80.5 189.5H62L50 179L40.5 167.5L45.5 156V127L55 118L71 112.5L85.5 118L96 127V156L102 167.5L93 179L80.5 189.5Z'
                          fill={colors[colorStates['AdultFPelvis']]}
                          onClick={() => handlePathClick('AdultFPelvis', 'Pelvis/Gu', 8, 'A')}
                        />
                      </g>
                    </svg>
                  </div>
                )}
                {selectedBodyView?.id === 2 && (
                  <div className='svg-container d-flex justify-content-center w-100'>
                    <svg
                      height={'100%'}
                      width={'100%'}
                      viewBox='0 0 141 412'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'>
                      <g id='AdultBurnsB'>
                        <path
                          id='65'
                          name='AdultBLegL'
                          d='M70 202L69 188L49.5 181L39 177.5L32.5 196L34 244.5L40.5 271.5L42 304.5L38 333.5L52.5 389.5L45 403V407L56.5 411.5H62L64 407V391L61 383.5L59.5 353.5L64 340V327.5L61 314L64 299L61 280.5L64 246V228L66.5 206.5L70 202Z'
                          fill={colors[colorStates['AdultBLegL']]}
                          onClick={() => handlePathClick('AdultBLegL', 'Left Leg', 65, 'P')}
                        />
                        <path
                          id='66'
                          name='AdultBLegR'
                          d='M73 202V188.5L93 182L103.5 179L110.5 196L109 244.5L102.5 271.5L101 304.5L105 333.5L90.5 389.5L98 403V407L86.5 411.5H81L79 407V391L82 383.5L83.5 353.5L79 340V327.5L82 314L79 299L82 280.5L79 246V228L76.5 206.5L73 202Z'
                          fill={colors[colorStates['AdultBLegR']]}
                          onClick={() => handlePathClick('AdultBLegR', 'Right Leg', 66, 'P')}
                        />
                        <path
                          id='2'
                          name='AdultBHead'
                          d='M59.5 2.5L70 0L82 2.5L91 12.5L89.5 37.5L85.5 38.5L84 48.5L81.5 52.5L83 57L77.5 57.5L70.5 57L63 57.5L58 57L59.5 52.5L59 48.5L56 38.5L52 37.5L51 14L59.5 2.5Z'
                          fill={colors[colorStates['AdultBHead']]}
                          onClick={() => handlePathClick('AdultBHead', 'Head', 2, 'P')}
                        />
                        <path
                          id='9'
                          name='AdultBBack'
                          d='M62 60L56 58.5L38 66L34 94L41.5 112L44.5 124L48 151L70.5 154.5L94.5 151L96.5 124L100.5 112L106 94L104 66L84.5 58.5L78.5 60H70.5H62Z'
                          fill={colors[colorStates['AdultBBack']]}
                          onClick={() => handlePathClick('AdultBBack', 'Back/Spine', 9, 'P')}
                        />
                        <path
                          id='37'
                          name='AdultBArmL'
                          d='M24.5 75L35.5 67.5L31 93L36 107L28 136V157L19.5 193.5L28 199L31.5 208L29.5 209.5L24.5 202L22 203V222L15 223.5L0 215.5L4 200.5L10 190L9 158.5L15 133.5L17 107.5V88.5L19.5 82.5L24.5 75Z'
                          fill={colors[colorStates['AdultBArmL']]}
                          onClick={() => handlePathClick('AdultBArmL', 'Left Arm', 37, 'P')}
                        />
                        <path
                          id='38'
                          name='AdultBArmR'
                          d='M116 75L106 67.5L109.5 93L104.5 107L112.5 136V157L121 193.5L112.5 199L109 208L111 209.5L116 202L118.5 203V222L125.5 223.5L140.5 215.5L136.5 200.5L130.5 190L131.5 158.5L125.5 133.5L123.5 107.5V88.5L121 82.5L116 75Z'
                          fill={colors[colorStates['AdultBArmR']]}
                          onClick={() => handlePathClick('AdultBArmR', 'Right Arm', 38, 'P')}
                        />
                        <path
                          id='8'
                          name='AdultBPelvis'
                          d='M74 184H69L50 179L40.5 175L45.5 156H50H55L71 158.5L85.5 156H91H96L102.5 176L93 179L74 184Z'
                          fill={colors[colorStates['AdultBPelvis']]}
                          onClick={() => handlePathClick('AdultBPelvis', 'Pelvis/Gu', 8, 'P')}
                        />
                      </g>
                    </svg>
                  </div>
                )}
              </IonCol>
              <IonCol size='3' className='p-0'>
                {sideSectionPosterior}
              </IonCol>
            </IonRow>
            <div className={isTablet ? 'burn-level-position right-16' : 'burn-level-position'}>
              <IonRow className='font-weight-bold font-size-15 mb-5 ml-5'> {t('burns.BurnLevel')}</IonRow>
              <IonRow className='d-flex justify-content-center'>
                <IonCol>
                  <IonLabel className='legend-item font-roboto-condensed font-size-13'>
                    <span className='legend-color first-degree'></span>
                    {t('burns.FirstDegree')}{' '}
                  </IonLabel>
                </IonCol>
              </IonRow>
              <IonRow className='d-flex justify-content-center'>
                <IonCol>
                  <IonLabel className='legend-item font-roboto-condensed font-size-13'>
                    <span className='legend-color second-degree'></span>
                    {t('burns.SecondDegree')}{' '}
                  </IonLabel>
                </IonCol>
              </IonRow>
              <IonRow className='d-flex justify-content-center'>
                <IonCol>
                  <IonLabel className='legend-item font-roboto-condensed font-size-13'>
                    <span className='legend-color third-degree'></span>
                    {t('burns.ThirdDegree')}{' '}
                  </IonLabel>
                </IonCol>
              </IonRow>
            </div>
          </div>
        )}
      </>
    </>
  )
}
export default BurnsRuleOfNinesContent
